(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('rfidConnect', {
        templateUrl: 'views/components/views/rfidConnect/rfidConnect.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'rfidConnectService', function ($stateParams, stateService, utilityService, translateService, modalService, rfidConnectService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                edit: {},
                itemsListRfidConnects: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region  LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await rfidConnectService.getEdit({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                return loadRfidConnects();
            }
            
            async function loadRfidConnects() {
                if (utilityService.validateParmsValue(vm.model.edit.argtype) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.argvalue) !== true) return;
                
                vm.model.itemsListRfidConnects = [];
                
                return vm.model.itemsListRfidConnects = await rfidConnectService.listRfidConnects({
                    argtype: vm.model.edit.argtype,
                    argvalue: vm.model.edit.argvalue
                });
            }

            // #endregion  LOAD PROCEDURE CALLS

            // #region TOGGLE FUNCTION
            
            vm.toggleChosen = function (item) {
                if (item.item_id === '0' || item.item_id === '-1') return;
                
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #endregion TOGGLE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;
                let selectedItems = [];

                vm.model.itemsListRfidConnects.forEach((item) => {
                    if (item.item_id === '0' || item.item_id === '-1') return;
                    if (item.item_is_selected === '0') return;

                    selectedItems.push({
                        argtype: item.argtype,
                        argvalue: item.argvalue
                    });
                });

                let mergeObj = {
                    rfid: vm.model.edit.rfid,
                    argtype: vm.model.edit.argtype,
                    argvalue: vm.model.edit.argvalue,
                    records: selectedItems
                };

                rfidConnectService.saveObj(mergeObj).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: (dialogItself) => {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
